import React, { useState } from 'react';
import Modal from 'react-modal';

// CSS
import {TerminosCondiciones, StyledModal, Titulo, Texto, Button, Img} from '../Css/StyledForm';
import { Contenedor } from '../Css/StyledHeader';

Modal.setAppElement('#root');

const DatosPacienteModal = () => {

    const [modalIsOpen, setModalIsOpen] = useState(false);

    return (
        <Contenedor>
            <Img onClick={() => setModalIsOpen(true)} width="37px" src={`/img/icono_ayuda.png`} />
            <TerminosCondiciones onClick={() => setModalIsOpen(true)} >Haz Click para Ayuda</TerminosCondiciones>
            <Modal isOpen={modalIsOpen} onRequestClose={() => setModalIsOpen(false)}>
                <StyledModal>
                    <Titulo>Datos necesarios para invitar paciente</Titulo>
                    <Texto>1. Datos del paciente (OBLIGATORIOS)<br />
                    - Nombre<br />
                    - Apellido<br />
                    - Sexo<br />
                    - Fecha de nacimiento<br />
                    - Email (el email debe ser único, no puede coincidir con el de los tutores)<br />
                    - Curso<br />
                    - ¿Repitió año? (Sí / No)<br /><br />

                    <b>2. Datos de los Tutores</b><br />
                    - <b>Tutor 1 (OBLIGATORIO)</b><br />
                    - Nombre<br />
                    - Apellido<br />
                    - Email (debe ser diferente al email del paciente y del tutor 2)<br /><br />

                    - <b>Tutor 2 (OPCIONAL)</b><br />
                    - Si decides completar los datos del tutor 2, <b>debes ingresar también</b>:<br />
                        - Nombre<br />
                        - Apellido<br />
                        - Email (debe ser diferente al email del paciente y del tutor 1)<br /><br />

                    <b>3. Condiciones para los Emails</b><br />
                    - Todos los emails deben ser diferentes (Paciente, Tutor 1, Tutor 2).<br />
                    - Los emails deben estar disponibles (no repetidos en otros registros del sistema).<br />
                    </Texto>
                    <div>
                        <Button onClick={() => setModalIsOpen(false)}>Cerrar</Button>
                    </div>
                </StyledModal>
            </Modal>
        </Contenedor>
    );
}
 
export default DatosPacienteModal;